import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import { connect, dispatch } from "../recontext/store";

const styles = theme => ({});

class ButtonEditTeam extends React.PureComponent {
  handleClickUpdateTeam() {
    dispatch("SHOW_UPDATE_TEAM_DIALOG");
  }

  render() {
    const { teamId, user } = this.props;
    if (!user || user.id !== teamId) return null;

    return (
      <IconButton onClick={this.handleClickUpdateTeam}>
        <Icon>edit</Icon>
      </IconButton>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(ButtonEditTeam));
